// extracted by mini-css-extract-plugin
export default {"cls1":"Banner-cls1_rpX","cls2":"Banner-cls2_VLe Banner-cls1_rpX"};